export default function(compare) {
  return this.eachBefore(function(node) {
    if (node.children) {
      node.children.sort(compare);
    }
  });
}



//////////////////
// WEBPACK FOOTER
// ../~/d3-hierarchy/src/hierarchy/sort.js
// module id = l55u
// module chunks = 0